import React, { useContext } from 'react';
import { Layout } from 'antd';
import EmployerNav from './nav';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { LivePassengersWithData } from '../../../components/live/LivePassengers';
import { MDPersonnel } from 'components/masterdata-2-0/pages';
import { GlobalAppStateContext } from 'context/global-app-state';
import cn from 'classnames';
import windowSizes from 'common/windowSizes';
import useUserGroups from 'hooks/useUserGroups';
import EmailTriggersPage from 'pages/app/management/email-triggers/email-triggers';
import VeriflytTicketsPage from "components/masterdata-2-0/pages/VeriflytTickets";
import checkpointRoutes from "routes/checkpoint";

const { Sider } = Layout;

function Content(props){
    const { noPadding, ...rest } = props;
    let style = {
        padding: 24
    };
    if (props.noPadding){
        style.padding = 0;
    }
    if (props.style){
        style = {
            ...style,
            ...props.style
        }
    }
    return <Layout.Content {...rest} style={style} />
}

function withPadding(Component){
    return () => <div style={{ padding: 24 }}>
        {<Component />}
    </div>
}

const EmployerRoutes = React.memo(({ userGroups }) => {

    return <Switch>
        <Route exact path="/app/passengers" component={withPadding(LivePassengersWithData)} />
        <Route exact path="/app/masterdata/personnel" component={MDPersonnel} />

        {checkpointRoutes}

        {userGroups.includes('flytsuite.compliance.ticket.all') ? (
            <Route exact path="/app/veriflyt/records" component={VeriflytTicketsPage} />
        ) : null}

        {!!(userGroups.includes('flytsuite.management.all') ||
            userGroups.includes('flytsuite.management.emailtriggers.all') ||
            userGroups.includes('flytsuite.master.all')) &&
            <Route
                exact
                path={'/app/management/email-triggers'}
                component={withPadding(EmailTriggersPage)}
            />
        }

        <Route render={() => <Redirect to="/app/passengers" />} />
    </Switch>
})

/**
 * Handles navigation and routes of employer branch of the application.
 */
function EmployerMain(){
    const [ userGroups ] = useUserGroups();
    const { state: { sidebarCollapsed }, setState } = useContext(GlobalAppStateContext);

    const history = useHistory();
    const { pathname } = useLocation();

    const navKey = pathname.split('/')[2];
    return <Layout className={cn({
        "mc-main-app-layout": true,
        "mc-main-app-layout-sider-open": (!sidebarCollapsed)
    })}>
        <div className="mc-main-app-layout-click-receiver" onClick={() => setState({ sidebarCollapsed: true })} />
        <Sider
            collapsed={sidebarCollapsed}
            width={200}
            className="mc-navigation"
        >
            <EmployerNav
                key={sidebarCollapsed ? 'collapsed' : 'expanded'}
                initiallyCollapsed={sidebarCollapsed}
                selectedKeys={[navKey]}
                onClick={({ key }) => {
                    history.push('/app/' + key);
                    if (window.innerWidth <= windowSizes.small){
                        setState({ sidebarCollapsed: true })
                    }
                }}
            />
        </Sider>
        <Layout.Content style={{ padding: 0 }}>
            <EmployerRoutes userGroups={userGroups} />
        </Layout.Content>
    </Layout>
}

export default EmployerMain